import React, { useState, useEffect, Fragment } from 'react'
import { Stack, Modal } from '~/components/_layouts'
import { useTranslation } from '~/hooks/useTranslation'
import { getApi } from '~/util/api'
import Spinner from '~/components/shared/Spinner'
import { useToast, Toaster } from '~/lib/ui/toast'
import DataTable from './DataTable'
import { Typography } from '~/components/_atoms/index'

const CoachChatHistory = () => {
  const { t } = useTranslation()
  const { toast } = useToast()

  const [isLoading, setIsLoading] = useState(false)
  const [chatHistories, setChatHistories] = useState([])
  const [selectedChat, setSelectedChat] = useState(null)

  useEffect(() => {
    const fetchChatHistories = async () => {
      setIsLoading(true)
      try {
        const response = await getApi().get('/coach_services/chat_histories')
        if (response.status === 200) {
          setChatHistories(response.data.chat_histories)
        } else {
          throw new Error('Failed to fetch chat histories')
        }
      } catch (error) {
        console.error('Error fetching chat histories:', error)
        setChatHistories([])
      } finally {
        setIsLoading(false)
      }
    }

    fetchChatHistories()
  }, [])

  return (
    <Stack spacing={3}>
      <Toaster />
      {isLoading ? (
        <div className="flex items-center justify-center">
          <Spinner show className="h-9 w-9" />
        </div>
      ) : (
        <>
          <Typography>{t('chat_histories.subtitle')}</Typography>
          <DataTable
            chatHistories={chatHistories}
            setChatHistories={setChatHistories}
            setSelectedChat={setSelectedChat}
            toast={toast}
          />
        </>
      )}
      <Modal
        title={selectedChat?.name}
        open={!!selectedChat}
        onClose={() => setSelectedChat(null)}
        size="md"
        variant="secondary"
      >
        <div className="grid grid-cols-[auto_1fr] gap-4">
          {selectedChat?.chat_text?.map((message, index) => {
            if (message.text?.match(/started chat from/)) return null
            const attachmentUrl =
              message.attachment_url ||
              message.action_target ||
              message.attachment?.url
            const attachmentName =
              message.attachment_name || message.attachment?.name
            return (
              <Fragment key={index}>
                <span
                  className={`name ${
                    message.who === selectedChat.coach.full_name
                      ? 'text-blue-500'
                      : 'text-red-500'
                  }`}
                >
                  {message.who === selectedChat.coach.full_name
                    ? message.who
                    : t('chat_histories.me')}
                  {':'}
                </span>
                <span>
                  {attachmentUrl ? (
                    <a
                      href={attachmentUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline hover:text-blue-800"
                    >
                      {message.text}
                      {attachmentName && (
                        <span className="sr-only"> ({attachmentName})</span>
                      )}
                    </a>
                  ) : (
                    message.text
                  )}
                </span>
              </Fragment>
            )
          })}
        </div>
      </Modal>
    </Stack>
  )
}

export default CoachChatHistory
